import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';
import { inventoryKitFormSchema } from './schemas/inventory-kit';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(inventoryKitFormSchema),
    defaultValues,
  });
}
